import { InputAdornment, TextField } from "@mui/material";
import { existsString } from "../store/validation";

export const NumericInput = ({
  caption,
  errorText,
  decimal = 0,
  disabled,
  label,
  left,
  min,
  max,
  onChanged,
  right,
  required,
  step,
  sx,
  valid = true,
  value,
}) => {
  const formatText = (value, _decimal) => {
    if (value !== undefined && value != null) {
      let result = value.toString();
      return result;
    } else return "";
  };

  const handleChange = (event, decimal) => {
    let value = event.target.value;
    if (decimal === undefined || decimal === 0) {
      value = value.replace(/[^0-9]/g, "");
      if (onChanged) onChanged(value);
    } else {
      const validNumber = new RegExp(/^\d*\.?\d*$/);
      if (onChanged && validNumber.test(value)) onChanged(value);
    }
  };

  const getEndAdornment = (value) => {
    if (existsString(value)) {
      return <InputAdornment position="end">{value}</InputAdornment>;
    } else return undefined;
  };

  const getStartAdornment = (value) => {
    if (existsString(value)) {
      return <InputAdornment position="start">{value}</InputAdornment>;
    } else return undefined;
  };

  return (
    <TextField
      type="number"
      label={label}
      disabled={disabled}
      fullWidth
      helperText={valid ? caption : errorText}
      required={required}
      sx={sx}
      error={!valid}
      value={formatText(value, decimal)}
      onChange={(value) => handleChange(value, decimal)}
      slotProps={{
        htmlInput: { type: "number", step: step, min: min, max: max },
        input: {
          type: "number",
          startAdornment: getStartAdornment(left),
          endAdornment: getEndAdornment(right),
        },
      }}
    />
  );
};
